import type { Paths } from "../../shared/usePrivacyNavigate";
import type { RegistrationVariant } from "./RegistrationVariantProvider";
import { prefetchRegistrationsGridViewAndForm, registrationsGridPageRoutes } from "./RegistrationsGridPage";
import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";

type routeProps = { variant: RegistrationVariant; path: string };
export const route = ({ variant, path }: routeProps): NavigationItemType["route"] => ({
  path,
  children: registrationsGridPageRoutes(variant),
});

export const to = (variant: RegistrationVariant) => (paths: Paths) => paths.registrationsGrid({ variant });
export const prefetch = (variant: RegistrationVariant) => prefetchRegistrationsGridViewAndForm(variant);
